import React, { useState, useMemo } from "react";

import { Row, Col } from "antd";
import orderBy from "lodash/orderBy";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Space from "shared/components/Space";
import { TabPanel, TabSwitcher } from "shared/components/Tab";
import { NAME_SPACES } from "shared/locals/constants";

import Actions from "./Actions";
import {
  PLANING,
  STATUS,
  PLANING_CONFIRM,
  DEFAULT,
  PAGE_CHUNKS,
  PLANING_WARNING,
} from "./Frames/constants";
import Default from "./Frames/Default";
import Modal from "./Frames/Modal";
import Planing from "./Frames/Planing";
import RendezvousConfirm from "./Frames/PlaningConfirm";
import RendezvousWarning from "./Frames/PlaningWarning";
import Status from "./Frames/Status";
import "./styles.scss";

const Component = ({ folder, refetch, folderStatus, fetchDataHandler }) => {
  const [intervention, setIntervention] = useState({});
  const { t } = useTranslation(NAME_SPACES.HOME);
  const [visible, setVisible] = useState();
  const [selectedAction, setSelectedAction] = useState({});
  const actionCode = useMemo(() => selectedAction?.code, [selectedAction]);

  const defaultStep = useMemo(() => {
    const pageChunk = folder?.extra?.workflow?.pageChunk;
    return PAGE_CHUNKS.includes(pageChunk) ? pageChunk : "NULL";
  }, [folder?.extra?.workflow?.pageChunk]);

  const actions = useMemo(() => {
    return orderBy(
      (folder?.extra?.workflow?.actions || []).filter(({ pageChunk }) =>
        PAGE_CHUNKS.includes(pageChunk),
      ),
      "pageChunk",
    );
  }, [folder]);

  const onPlanIntervention = (_data) => {
    setIntervention(_data);
    refetch();
  };

  /**
   * Status update handler. The handler executes parent data-fetch and then set selectedAction to `null`. The last operation is necessary to show folder's current page chunk
   * @param _data changed status-data
   * @returns {Promise<void>}
   */
  // eslint-disable-next-line no-unused-vars
  const onStatusUpdate = async (_data) => {
    await fetchDataHandler();
    setSelectedAction({});
  };

  return (
    <TabSwitcher defaultStep={defaultStep}>
      <div className={"page-card"}>
        <Row className="rowContainer">
          <Col xl={6}>
            <div className={"spaced-row"}>
              <p className={"title"}>{t("ADVANCEMENT")}</p>
            </div>
            <Space h={48} sh={28} />
            <Actions
              folder={actions}
              selected={selectedAction}
              onSelect={setSelectedAction}
            />
            <Space h={48} />
          </Col>
          <Col xl={18}>
            <div className={"outlined"}>
              <TabPanel whenActive={DEFAULT}>
                <Default
                  folder={folder}
                  folderStatus={folderStatus}
                  actionCode={actionCode}
                  onBack={() => setSelectedAction({})}
                  onStatusUpdate={onStatusUpdate}
                />
              </TabPanel>
              <TabPanel whenActive={STATUS}>
                <Status folderStatus={folderStatus} />
              </TabPanel>
              <TabPanel whenActive={PLANING}>
                <Planing
                  folder={folder}
                  folderStatus={folderStatus}
                  onChange={onPlanIntervention}
                  actionCode={actionCode}
                />
              </TabPanel>
              <TabPanel whenActive={PLANING_CONFIRM}>
                <RendezvousConfirm folder={intervention} />
              </TabPanel>
              <TabPanel whenActive={PLANING_WARNING}>
                <RendezvousWarning />
              </TabPanel>
            </div>
          </Col>
        </Row>
        <Modal visible={visible} setIsModalVisible={setVisible} />
      </div>
    </TabSwitcher>
  );
};

Component.propTypes = {
  folder: PropTypes.object.isRequired,
  folderStatus: PropTypes.object.isRequired,
  refetch: PropTypes.func.isRequired,
  fetchDataHandler: PropTypes.func.isRequired,
};

export default Component;
